import { l } from '@manychat/manyui'

import { IExternalTrigger } from 'apps/externalTriggers/externalTriggerInterfaces'
import { AppIdToIconMapping } from 'common/builder/components/builder/TriggerPicker/constants'
import {
  ConverterRule,
  TriggersConverterRulePayload,
} from 'common/builder/components/chart/FlowChart/lib/types'
import {
  FlowChartTrigger,
  FlowChartTriggerIconType,
} from 'common/builder/components/chart/FlowChart/types/FlowChartTrigger'
import { isTriggerInteractive } from 'common/builder/utils/isTriggerInteractive'
import { getApplicationById } from 'common/core/selectors/appSelectors'
import { TriggerType } from 'common/flow/constants/TriggerType'
import { IFlowTrigger } from 'common/flow/flowInterfaces'

export const ExternalTriggerGenericTriggerConverterRule: ConverterRule<
  IFlowTrigger,
  FlowChartTrigger,
  TriggersConverterRulePayload
> = {
  predicate: (entity: IFlowTrigger) => entity?.triggerType === TriggerType.EXTERNAL_TRIGGER,
  convert: (entity: IExternalTrigger, { state }) => {
    const application = getApplicationById('appId' in entity && entity.appId ? entity.appId : null)(
      state,
    )

    const trigger: FlowChartTrigger = {
      id: entity.triggerId,
      icon: AppIdToIconMapping[entity.appId]
        ? {
            type: FlowChartTriggerIconType.ICON,
            icon: AppIdToIconMapping[entity.appId],
          }
        : {
            type: FlowChartTriggerIconType.EXTERNAL,
            icon: application?.avatar?.url || null,
          },
      title: entity.externalTriggerTypeName || l.translate('Empty'),
      subtitle: entity.caption ? [entity.caption] : [],
      subtitleIcon: null,
      isActive: entity.enabled,
      isInteractive: isTriggerInteractive(entity),
    }

    return trigger
  },
}
